import { api } from './api';
import { CourierListResponse } from '../types/courier';

export const courierService = {
  async getAllCouriers(): Promise<CourierListResponse> {
    const { data } = await api.get<CourierListResponse>('/courier/all');
    return data;
  },
};
